import { AppRouteProps } from "@harea/component";
import React from "react";

const DepartmentsContainer = React.lazy(() => import('./containers/UserOrganisationDepartmentsList'))

export const DepartmentsRoutes: Array<AppRouteProps> = [
    {
        path: 'departments',
        roles: ["DEPARTMENT"],
        title: "Generic.UserOrganisation.About.title",
        element: <DepartmentsContainer />
    }
]